import Events from '@utilities/events';

const CLOSE_MESSAGE_ACTIVE_CLASS = 'close-message--is-active';

const CLOSE_MODAL_BUTTON_HOOK = '[js-hook-button-application-form-close]';
const CLOSE_BUTTON_HOOK = '[js-hook-application-form-open-close-message]';
const CLOSE_MESSAGE_HOOK = '[js-hook-application-form-close-message]';
const MESSAGE_CLOSE_BUTTON_HOOK = '[js-hook-application-form-message-close]';

class applicationForm {
    constructor(element) {
        this.element = element;
        this.openCloseMessageButton = this.element.querySelector(CLOSE_BUTTON_HOOK);
        this.formModalCloseButton = this.element.querySelector(CLOSE_MODAL_BUTTON_HOOK);
        this.formCloseMessage = this.element.querySelector(CLOSE_MESSAGE_HOOK);
        this.closeCloseMessageButtons = [...this.element.querySelectorAll(MESSAGE_CLOSE_BUTTON_HOOK)];

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.openCloseMessageButton.addEventListener('click', () => {
            this.formCloseMessage.classList.add(CLOSE_MESSAGE_ACTIVE_CLASS);
        });

        this.closeCloseMessageButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.formCloseMessage.classList.remove(CLOSE_MESSAGE_ACTIVE_CLASS);
            });
        });

        this.formModalCloseButton.addEventListener('click', () => {
            this.formCloseMessage.classList.remove(CLOSE_MESSAGE_ACTIVE_CLASS);
            Events.$trigger('modal[application-form]::close');
        });

        Events.$on('modal[application-form]::open', () => {
            Events.$trigger('step-form::focus');
        });
    }
}

export default applicationForm;
